import styled from 'styled-components';

type StyledContainerProps = {
  isJobPostSelected: boolean;
};
export const StyledContainer = styled.div<StyledContainerProps>`
  border: 1px solid
    ${({ theme, isJobPostSelected }) =>
      isJobPostSelected ? theme.palette.primary[0] : theme.palette.stroke[0]};
  border-radius: 12px;
`;

export const StyleMainContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  color: ${({ theme }) => theme.palette.text[0]};
  padding: 19px;
  border-bottom: 1px solid ${({ theme }) => theme.palette.stroke[0]};

  @media (max-width: 768px) {
    padding: 15px;
  }
`;
